import { render, staticRenderFns } from "./YouTubeEmbed.vue?vue&type=template&id=45b1e003&scoped=true"
import script from "./YouTubeEmbed.vue?vue&type=script&lang=js"
export * from "./YouTubeEmbed.vue?vue&type=script&lang=js"
import style0 from "./YouTubeEmbed.vue?vue&type=style&index=0&id=45b1e003&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b1e003",
  null
  
)

export default component.exports